import axios from 'axios'
import router from '../router'
import {Message} from 'element-ui'
import * as baseMethods from '../utils/baseMethod'

export const Axios = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 3000000
})

export const RestAxios = axios.create({
  baseURL: process.env.REST_API,
  timeout: 3000000
})

Axios.interceptors.request.use(config => {
  const userInfo = baseMethods.getLocalObj('userInfo')
  //const userInfo = true
  if (userInfo) {
    config.headers.Authorization = `Bearer ${userInfo.token}`
    
    //config.headers.Authorization = `Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxNzcxMDQ4MDQwNSIsInVzZXJfdHlwZSI6IkNVU1RPTUVSIiwidXNlcl9pZCI6MTk5NDUyLCJleHAiOjE5OTcxNzExNTh9.XnOSV_EaRX5EU9AXH3izyZ-Z3uj4IPCy3xQKkXe2_sMe-R9nZ2sWKs2WoOjDdlBBfrFK26QyQmFIx83gsHz5iw`
    // config.headers.Authorization = `${userInfo.token}`
    config.headers.channel = `customer-ui`
  }
  return config
}, error => {
  console.error('错误的传参', 'fail')
  return Promise.reject(error)
})

Axios.interceptors.response.use(
  res => {
    return res
  },
  error => {
    if (!error.response) {
      // Message.error('网络错误')
      return
    }

    switch (error.response.status) {
      case 401:
        // 清除token信息并跳转到登录页面
        localStorage.removeItem('userInfo')
        localStorage.clear()
        if (error.response.config.url.indexOf('login') > -1) {
          Message.error(error.response.data.detail)
        } else {
          // router.replace('/login')
          window.location = decodeURIComponent(process.env.SHOP_URL + "member/login?redirectUrlTs=" + router.currentRoute.fullPath)
        }
        break

      case 400:
      case 500:
        const msg = error.response.data.detail
        if (msg) {
          Message.error(msg)
        } else if (error.response.data.title) {
          Message.error(error.response.data.title)
        }
        break
    }
    return Promise.reject(error.response.data)
  }
)

RestAxios.interceptors.request.use(config => {
  const userInfo = baseMethods.getLocalObj('userInfo')
  //const userInfo = true
  if (userInfo) {
    config.headers.Authorization = `Bearer ${userInfo.token}`
    //config.headers.Authorization = `Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxNzcxMDQ4MDQwNSIsInVzZXJfdHlwZSI6IkNVU1RPTUVSIiwidXNlcl9pZCI6MTk5NDUyLCJleHAiOjE5OTcxNzExNTh9.XnOSV_EaRX5EU9AXH3izyZ-Z3uj4IPCy3xQKkXe2_sMe-R9nZ2sWKs2WoOjDdlBBfrFK26QyQmFIx83gsHz5iw`
    config.headers.channel = `customer-ui`
  }
  if (config.url.indexOf('detail-excel') > -1 || config.url.indexOf('docs-download') > -1 || config.url.indexOf('composite-report-xlsx') > -1) {
    config.responseType = 'blob'
  }
  if (config.url.indexOf('gene-price') > -1) {
    config.headers['Content-Type'] = 'text/xml'
  }
  return config
}, error => {
  console.error('错误的传参', 'fail')
  return Promise.reject(error)
})

RestAxios.interceptors.response.use(
  res => {
    return res
  },
  error => {
    if (!error.response) {
      // Toast('网络错误')
      return
    }
    switch (error.response.status) {

      case 401:
        // 清除token信息并跳转到登录页面
        localStorage.removeItem('userInfo')
        localStorage.clear()
        // router.replace('/login')
        window.location =  decodeURIComponent(process.env.SHOP_URL + "member/login?redirectUrlTs="+ router.currentRoute.fullPath)
        break

      case 400:
      case 500:
        if (error.response.config.url.indexOf('docs-download') > -1) {
          Message.error('当前工单无可下载的结果文档')
        }
        if (error.response.data.detail) {
          Message.error(error.response.data.detail)
        }
        if (error.response.data.title) {
          Message.error(error.response.data.title)
        }
        break
    }
    return Promise.reject(error.response.data)
  }
)



// WEBPACK FOOTER //
// ./src/utils/Axios.js